import axios from 'axios'
import library from '../../../utils/Library'

export const addAppVersionRTEnviroments = async (
  appCode,
  appPlatformCode,
  appVersionCode,
  appVersionDesc
) => {
  const TOKEN = sessionStorage.getItem('token')
  const URL = `${library.getBaseAPIUrl(
    'version_enviroments'
  )}/addAppVersionRTEnviroments`

  return await axios({
    url: URL,
    method: 'POST',
    headers: {
      Authorization: `Bearer ${TOKEN}`
    },
    data: {
      appCode,
      appPlatformCode,
      appVersionCode,
      appVersionDesc,
      releaseDate: new Date().toISOString()
    }
  })
}
